document.addEventListener('DOMContentLoaded', function () {
  
  /* ========================================================
     1. PRODUCT DETAIL PAGE MODIFICATION (DESKTOP ONLY)
     ======================================================== */
  if (window.innerWidth >= 768) {
    const productMedia = document.querySelector('hdt-product-media');
    const tabsSection = document.querySelector('.hdt-section-main-product-tabs');

    if (productMedia && tabsSection) {
      if (productMedia.nextElementSibling !== tabsSection) {
        productMedia.parentNode.insertBefore(tabsSection, productMedia.nextSibling);
      }
    }
  }

  /* ========================================================
     2. OUR PANEL HORIZONTAL SLIDER CONTROLS (FULL DOM OVERRIDE)
     ======================================================== */
  function initializeTeamSlider() {
    // 1. Target the main app custom section element root
    const appRoot = document.querySelector('[class*="ai-team-tabs"]') || document.querySelector('team-section-aa2ttckjpmlpfrgxaigenblock618e7b4wkqdf9');
    if (!appRoot) return false;

    // 2. Target the inner row layout container that contains both the cards and the text column
    const mainRowContainer = appRoot.querySelector('.hdt-row') || appRoot.querySelector('.hdt-grid') || appRoot.firstElementChild;
    if (!mainRowContainer) return false;

    // 3. Locate the card container track and the text block column
    const gridTrack = appRoot.querySelector('.hdt-grid') || appRoot.querySelector('[class*="grid"]');
    const sections = mainRowContainer.children;
    let textColumn = null;

    // Distinguish the text block column from the image grid column
    for (let sec of sections) {
      if (!sec.contains(gridTrack) && (sec.innerText.includes('vision') || sec.querySelector('h2') || sec.querySelector('p'))) {
        textColumn = sec;
      }
    }

    if (!gridTrack || gridTrack.children.length === 0) return false;

    // 4. Force the primary section container to stack vertically instead of splitting side-by-side
    mainRowContainer.style.setProperty('display', 'flex', 'important');
    mainRowContainer.style.setProperty('flex-direction', 'column', 'important');
    mainRowContainer.style.setProperty('gap', '30px', 'important');
    mainRowContainer.style.setProperty('width', '100%', 'important');
    mainRowContainer.style.setProperty('max-width', '100%', 'important');

    // 5. If a distinct text column exists, ensure it takes up full-width at the top
    if (textColumn) {
      textColumn.style.setProperty('width', '100%', 'important');
      textColumn.style.setProperty('max-width', '100%', 'important');
      textColumn.style.setProperty('flex', '0 0 100%', 'important');
      textColumn.style.setProperty('padding-bottom', '10px', 'important');
      
      // Move the text block dynamically to the top if the app rendered it behind/beside the cards
      if (mainRowContainer.firstElementChild !== textColumn) {
        mainRowContainer.insertBefore(textColumn, mainRowContainer.firstElementChild);
      }
    }

    // 6. Expand the image grid column to break out into a full-width track layout
    const gridWrapper = gridTrack.parentElement;
    if (gridWrapper && gridWrapper !== mainRowContainer) {
      gridWrapper.style.setProperty('width', '100%', 'important');
      gridWrapper.style.setProperty('max-width', '100%', 'important');
      gridWrapper.style.setProperty('flex', '0 0 100%', 'important');
      gridWrapper.style.setProperty('overflow', 'visible', 'important');
    }

    // 7. Force the profile cards into a smooth, single horizontal scroll row
    gridTrack.style.setProperty('display', 'flex', 'important');
    gridTrack.style.setProperty('flex-direction', 'row', 'important');
    gridTrack.style.setProperty('flex-wrap', 'nowrap', 'important');
    gridTrack.style.setProperty('overflow-x', 'auto', 'important');
    gridTrack.style.setProperty('scroll-behavior', 'smooth', 'important');
    gridTrack.style.setProperty('gap', '20px', 'important');
    gridTrack.style.setProperty('padding', '15px 5px', 'important');
    gridTrack.style.setProperty('width', '100%', 'important');
    gridTrack.style.webkitOverflowScrolling = 'touch';
    gridTrack.style.scrollbarWidth = 'none'; // Hide Firefox scrollbar

    // Inject custom hidden scrollbar style rules directly for Webkit engines
    if (!document.getElementById('custom-scrollbar-hide')) {
      const styleSheet = document.createElement("style");
      styleSheet.id = "custom-scrollbar-hide";
      styleSheet.innerText = `
        [class*="ai-team-tabs"] .hdt-grid::-webkit-scrollbar,
        team-section-aa2ttckjpmlpfrgxaigenblock618e7b4wkqdf9 .hdt-grid::-webkit-scrollbar {
          display: none !important;
        }
      `;
      document.head.appendChild(styleSheet);
    }

    // 8. Lock structural widths for individual profile columns so they do not scale down or compress
    const memberCards = gridTrack.children;
    for (let card of memberCards) {
      card.style.setProperty('flex', '0 0 260px', 'important');
      card.style.setProperty('min-width', '260px', 'important');
      card.style.setProperty('max-width', '280px', 'important');
      card.style.setProperty('white-space', 'normal', 'important');
    }

    // 9. Configure visibility parent targets to host the custom navigation arrows safely
    appRoot.style.setProperty('position', 'relative', 'important');
    appRoot.style.setProperty('overflow', 'visible', 'important');
    if (appRoot.parentElement) appRoot.parentElement.style.setProperty('overflow', 'visible', 'important');

    // 10. Append interactive slider control buttons cleanly to the layout track
    if (!appRoot.querySelector('.custom-slider-arrow')) {
      const prevBtn = document.createElement('button');
      prevBtn.className = 'custom-slider-arrow prev-arrow';
      prevBtn.innerHTML = '&#10094;';
      prevBtn.style.cssText = "position:absolute; left:-25px; top:60%; transform:translateY(-50%); z-index:10; background:#fff; border:1px solid #ddd; width:40px; height:40px; border-radius:50%; cursor:pointer; box-shadow:0 2px 5px rgba(0,0,0,0.15); display:flex; align-items:center; justify-content:center;";

      const nextBtn = document.createElement('button');
      nextBtn.className = 'custom-slider-arrow next-arrow';
      nextBtn.innerHTML = '&#10095;';
      nextBtn.style.cssText = "position:absolute; right:-25px; top:60%; transform:translateY(-50%); z-index:10; background:#fff; border:1px solid #ddd; width:40px; height:40px; border-radius:50%; cursor:pointer; box-shadow:0 2px 5px rgba(0,0,0,0.15); display:flex; align-items:center; justify-content:center;";

      appRoot.appendChild(prevBtn);
      appRoot.appendChild(nextBtn);

      // Scroll Event Listeners
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        gridTrack.scrollBy({ left: -280, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        gridTrack.scrollBy({ left: 280, behavior: 'smooth' });
      });
    }

    return true; 
  }

  // --- ASYNC POLLING RENDER WATCHDOG ---
  if (!initializeTeamSlider()) {
    let attempts = 0;
    const sliderPollInterval = setInterval(function() {
      attempts++;
      const success = initializeTeamSlider();
      if (success || attempts > 30) {
        clearInterval(sliderPollInterval);
      }
    }, 200);
  }

});